import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { API } from "@/lib/auth";

const KEY = "pick_alerts_on";
const notify = (title, body) => {
  if ("Notification" in window && Notification.permission === "granted") new Notification(title, { body });
  toast(title, { description: body });
};

export const PickAlerts = () => {
  const [on, setOn] = useState(localStorage.getItem(KEY) === "1");
  const seen = useRef(new Set(JSON.parse(localStorage.getItem("pick_alerts_seen") || "[]")));
  useEffect(() => {
    if (!on) return undefined;
    const check = async () => {
      try {
        const [p, mv] = await Promise.all([axios.get(`${API}/predict/picks`), axios.get(`${API}/predict/markets`, { params: { sort: "movers", limit: 5 } })]);
        const first = seen.current.size === 0;
        Object.values(p.data.categories).flatMap((c) => c.picks).forEach((x) => {
          if (!seen.current.has(x.slug) && !first) notify(`New data pick: ${x.pick_name} ${Math.round(x.chance * 100)}%`, x.label);
          seen.current.add(x.slug);
        });
        mv.data.markets.filter((m) => Math.abs(m.move_1h || 0) >= 0.05).forEach((m) => {
          const k = `mv:${m.slug}:${Math.round(m.move_1h * 100)}`;
          if (!seen.current.has(k)) notify(`Big move: ${m.move_1h > 0 ? "+" : ""}${Math.round(m.move_1h * 100)} pts in 1h`, m.label);
          seen.current.add(k);
        });
        localStorage.setItem("pick_alerts_seen", JSON.stringify([...seen.current].slice(-400)));
      } catch { /* next poll retries */ }
    };
    check();
    const id = setInterval(check, 300000);
    return () => clearInterval(id);
  }, [on]);
  const toggle = async (v) => {
    if (v && "Notification" in window && Notification.permission === "default") await Notification.requestPermission();
    localStorage.setItem(KEY, v ? "1" : "0"); setOn(v);
    toast.success(v ? "You'll get alerts for new picks and big price moves" : "Pick alerts off");
  };
  return (
    <label className="glass px-4 py-3 flex items-center justify-between gap-3 text-sm cursor-pointer" data-testid="pick-alerts">
      <span className="flex items-center gap-2"><BellRing className="w-4 h-4 text-[var(--cyan)]" />Alert me about new data picks & big price moves</span>
      <Switch checked={on} onCheckedChange={toggle} data-testid="pick-alerts-switch" />
    </label>
  );
};
